import { between, required, confirmed, email } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import * as moment from 'moment'

extend('required', {
  ...required,
  message: '{_field_} is required (〃∀〃)ゞ'
})

extend('email', {
  ...email,
  message: '(´｡• ω •｡`) This must be a valid email address'
})

extend('confirmed', {
  ...confirmed,
  message: 'This field confirmation does not match つ´Д`)つ'
})

extend('before', {
  message: 'You must be older than 13 (シ_ _)シ',
  validate: value => value <= moment().subtract(13, 'years')
})

extend('between', {
  ...between,
  message: '{_field_} must be between {min} and {max} characters ╭( ･ㅂ･)و',
  params: ['min', 'max'],
  validate (value, { min, max }) {
    return value.length >= min && value.length <= max
  }
})
